/** The artist closed the sign-in surface. Not an error to shout about. */
export class ArtistPortalAuthCancelledError extends Error {
  constructor() {
    super('Artist portal sign-in was cancelled');
    this.name = 'ArtistPortalAuthCancelledError';
  }
}
